<template><div><dt-notice kind="warning" title="Use DtText over CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Reach for the <a href="/components/text" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtText</a> component before considering any typography utility.
</dt-notice>
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-ta-{n}</code> to change an element's text alignment.</p>
<code-example source-code='&lt;div class=&quot;d-code--sm d-docsite-code d-ws-nowrap&quot;&gt;.d-ta-start&lt;/div&gt;
&lt;div&gt;&lt;p class=&quot;d-bgc-moderate d-ta-start&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;&lt;/div&gt;
&lt;div class=&quot;d-code--sm d-docsite-code d-ws-nowrap&quot;&gt;.d-ta-center&lt;/div&gt;
&lt;div&gt;&lt;p class=&quot;d-bgc-moderate d-ta-center&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;&lt;/div&gt;
&lt;div class=&quot;d-code--sm d-docsite-code d-ws-nowrap&quot;&gt;.d-ta-end&lt;/div&gt;
&lt;div&gt;&lt;p class=&quot;d-bgc-moderate d-ta-end&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;&lt;/div&gt;
&lt;div class=&quot;d-code--sm d-docsite-code d-ws-nowrap&quot;&gt;.d-ta-justify&lt;/div&gt;
&lt;div&gt;&lt;p class=&quot;d-bgc-moderate d-ta-justify d-w-500&quot;&gt;The quick brown fox jumps over the lazy dog. This needs a width applied to it to work.&lt;/p&gt;&lt;/div&gt;
&lt;div class=&quot;d-code--sm d-docsite-code d-ws-nowrap&quot;&gt;.d-ta-unset&lt;/div&gt;
&lt;div&gt;&lt;p class=&quot;d-bgc-moderate d-ta-unset&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;&lt;/div&gt;'>
<div data-demo-wrapper class="d-w100p d-d-grid d-g-200 d-ai-center lg:d-fs-100" style="grid-template-columns: auto 1fr">
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-ta-start</div>
  <div><p class="d-bgc-moderate d-ta-start">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-ta-center</div>
  <div><p class="d-bgc-moderate d-ta-center">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-ta-end</div>
  <div><p class="d-bgc-moderate d-ta-end">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-ta-justify</div>
  <div><p class="d-bgc-moderate d-ta-justify d-w-500">The quick brown fox jumps over the lazy dog. This needs a width applied to it to work.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-ta-unset</div>
  <div><p class="d-bgc-moderate d-ta-unset">The quick brown fox jumps over the lazy dog.</p></div>
</div>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in align">
        <th class="d-code--sm d-docsite-code">
          .d-ta-{{ i.class }}
          <dt-badge v-if="i.deprecated" type="critical" class="d-ff-sans">Deprecated</dt-badge>
        </th>
        <td class="d-code--sm">text-align: {{ i.value }} !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { align } from '@data/type.json';
</script>